import React from 'react';
import { Navigate } from 'react-router-dom';

interface GuestRouteProps {
  children: React.ReactNode;
}

const FLAG_KEY = 'whipt_guest_access';

export function GuestRoute({ children }: GuestRouteProps) {
  const hasAccess = sessionStorage.getItem(FLAG_KEY) === 'true';

  if (!hasAccess) {
    return <Navigate to="/guest" replace />;
  }

  return <>{children}</>;
}

export function setGuestAccessFlag() {
  sessionStorage.setItem(FLAG_KEY, 'true');
}

export function clearGuestAccessFlag() {
  sessionStorage.removeItem(FLAG_KEY);
}
